/* ═══════════════════════════════════════════════════════════
   ALBA · movimiento
   Observado cuadro a cuadro de eightsleep.com (grabación 2026-09-07):

   1. La barra pasa de transparente sobre el hero a sólida blanca de
      forma CONTINUA — no salta en un umbral, interpola con el scroll.
   2. Los titulares se revelan PALABRA POR PALABRA atados a la posición
      del scroll, y se retraen al subir. No es un disparo único: es una
      función de la posición.

   Sin librerías. Se apaga solo si el sistema pide menos movimiento.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var raiz = document.documentElement;
  var menos = window.matchMedia('(prefers-reduced-motion: reduce)');
  var titulares = [];
  var medios = [];
  var pendiente = false;

  function limita(v, min, max) { return v < min ? min : (v > max ? max : v); }

  /* ── 1 · Barra: interpolación continua ──
     0 arriba del todo, 1 pasados 220 px. El CSS usa --barra para el
     fondo y la sombra, así que el cambio acompaña al scroll. */
  /* Umbral medido en el original: la barra de anuncio aguanta hasta ~140 px
     y ahí se pliega. No es una interpolación continua — es un cambio de
     estado, y la curva la pone el CSS. La histéresis de 30 px evita que
     parpadee cuando alguien se queda justo en el borde. */
  var UMBRAL = 140, HIST = 30, bajado = false;

  /* `alba-movido`: hubo scroll, aunque sea poco. En celular la barra es
     transparente solo mientras la página está quieta arriba; en cuanto algo
     empieza a pasar por debajo, entra el vidrio. Esperar al umbral de 140
     dejaba la galería de la PDP cruzando una barra sin desenfoque. */
  var movido = false;
  function pintaBarra() {
    var y = window.scrollY;
    if (!movido && y > 4) { movido = true; raiz.classList.add('alba-movido'); }
    else if (movido && y <= 4) { movido = false; raiz.classList.remove('alba-movido'); }
    if (!bajado && y > UMBRAL) { bajado = true; raiz.classList.add('alba-bajado'); }
    else if (bajado && y < UMBRAL - HIST) { bajado = false; raiz.classList.remove('alba-bajado'); }
  }

  /* ── 2 · Titulares palabra por palabra ──
     Cada titular publica su avance en --p (0 a 1). El CSS decide la
     opacidad de cada palabra según su índice. Al subir, --p baja y las
     palabras se retraen solas: el movimiento es reversible por diseño. */
  function partePalabras(el) {
    var texto = el.textContent.trim();
    if (!texto) return null;
    var palabras = texto.split(/\s+/);

    // La unidad es la LETRA, no la palabra: el frente de aparición recorre
    // el interior de cada palabra. Pero cada palabra va envuelta en su
    // propio contenedor sin saltos, para que el texto siga cortando por
    // los espacios y no a mitad de palabra.
    var frag = document.createDocumentFragment();
    var k = 0;
    palabras.forEach(function (w, wi) {
      var caja = document.createElement('span');
      caja.className = 'alba-w';
      for (var c = 0; c < w.length; c++) {
        var letra = document.createElement('span');
        letra.className = 'alba-p';
        letra.style.setProperty('--i', k++);
        letra.textContent = w[c];
        caja.appendChild(letra);
      }
      frag.appendChild(caja);
      if (wi < palabras.length - 1) frag.appendChild(document.createTextNode(' '));
    });

    // Partir el texto en letras haría que un lector de pantalla lo
    // deletreara. El aria-label devuelve la frase entera.
    el.setAttribute('aria-label', texto);
    el.textContent = '';
    el.appendChild(frag);
    el.style.setProperty('--n', k);
    return { el: el };
  }

  function pintaTitulares() {
    var alto = window.innerHeight;
    var scroll = window.scrollY;
    var maxScroll = document.documentElement.scrollHeight - alto;

    // La banda donde ocurre el revelado, en fracción de pantalla contando
    // desde arriba. Dos perillas:
    //   INICIO — dónde empieza a encenderse. Más bajo (0.9) = empieza casi
    //            al asomar por abajo; más alto (0.6) = tarda más.
    //   FIN    — dónde termina. Más alto (0.15) = acaba casi en el borde
    //            superior; más bajo (0.5) = acaba a media pantalla.
    // Se dejan en el centro: el revelado ocurre mientras el titular cruza
    // la mitad de la pantalla, que es donde se está mirando.
    var inicio = alto * 0.85;
    var fin = alto * 0.55;

    for (var i = 0; i < titulares.length; i++) {
      var el = titulares[i].el;
      var arriba = el.getBoundingClientRect().top + scroll;   // posición absoluta

      // Scroll al que arrancaría y al que terminaría el recorrido.
      var desde = arriba - inicio;
      var hasta = arriba - fin;

      // Y aquí está la trampa que ya costó una sesión: un titular al final
      // de la página NUNCA llega al 25% — se acaba el documento antes. Si
      // el final no es alcanzable, se comprime el recorrido para que termine
      // con el scroll que de verdad queda. Nada se queda a medio encender.
      if (hasta > maxScroll) hasta = maxScroll;
      if (hasta <= desde) { el.style.setProperty('--p', '1'); continue; }

      el.style.setProperty('--p', limita((scroll - desde) / (hasta - desde), 0, 1).toFixed(3));
    }
  }

  /* ── 3 · Medios con deriva ──
     Cada medio publica --m: 0 cuando su borde superior toca el fondo de
     la ventana, 1 cuando su borde inferior sale por arriba. El CSS usa ese
     avance para desplazar la foto dentro de su marco (parallax) y para la
     entrada. Medido en el original: la imagen recorre 1.25 veces el scroll,
     o sea una deriva relativa de ~0.25 hacia arriba al bajar. */
  function pintaMedios() {
    var alto = window.innerHeight;
    for (var i = 0; i < medios.length; i++) {
      var el = medios[i];
      var r = el.getBoundingClientRect();
      var m = (alto - r.top) / (alto + r.height);
      el.style.setProperty('--m', limita(m, 0, 1).toFixed(4));
    }
  }

  function alScroll() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pintaBarra();
      if (titulares.length) pintaTitulares();
      if (medios.length) pintaMedios();
      pendiente = false;
    });
  }

  /* La altura de la barra de anuncio la decide el merchant desde el editor,
     así que se mide y se publica en vez de darla por sentada. */
  function mideAnuncio() {
    var a = document.querySelector('.announcement-bar-section');
    if (a) raiz.style.setProperty('--alba-anuncio', Math.round(a.getBoundingClientRect().height) + 'px');
    // La sección del header tira del contenido hacia arriba exactamente lo
    // que mide. Su altura depende de ajustes que el merchant controla, así
    // que se mide en vez de darse por sentada.
    var h = document.querySelector('.section-header');
    if (h) raiz.style.setProperty('--alba-header-alto', Math.round(h.getBoundingClientRect().height) + 'px');
  }

  function arranca() {
    mideAnuncio();
    window.addEventListener('resize', mideAnuncio, { passive: true });
    pintaBarra();
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });

    if (menos.matches) return;

    medios = [].slice.call(document.querySelectorAll('[data-alba-medio]'));
    if (medios.length) pintaMedios();

    var nodos = document.querySelectorAll('[data-alba-palabras]');
    for (var i = 0; i < nodos.length; i++) {
      var t = partePalabras(nodos[i]);
      if (t) titulares.push(t);
    }
    if (!titulares.length && !medios.length) return;

    // El texto nace visible. Solo lo animamos tras confirmar que
    // podemos devolverlo a visible en cualquier momento.
    raiz.classList.add('alba-anima');
    pintaTitulares();

    // Red de seguridad: al salir o imprimir, todo vuelve a ser legible.
    function rendirse() { raiz.classList.remove('alba-anima'); }
    window.addEventListener('pagehide', rendirse);
    if (window.matchMedia) {
      var impr = window.matchMedia('print');
      if (impr.addEventListener) impr.addEventListener('change', rendirse);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
